export const ASSESSMENT_DND_TYPES = {
  AssessmentInputOption: 'Assessment Input Option',
};

export const FIELD_TYPES = {
  multipleChoice: 'Multiple Choice',
  radio: 'Radio Button',
};
